/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatSortCriteria {
    getFixupPrototypeFunction() { return AgentChatSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AgentChatSortCriteria>): AgentChatSortCriteria {
        let obj = Object.assign(new AgentChatSortCriteria(), model);
        AgentChatSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatSortCriteria>): AgentChatSortCriteria {
        if (!model) return null;
        return AgentChatSortCriteria.newInstance(<AgentChatSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatSortCriteria) {
        if (!obj) return;

        models.AgentChatSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatSortCriteria): boolean {
        Object.setPrototypeOf(obj, AgentChatSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AgentChatSortColumn;

    ascending: boolean;

}
